import { FileHelper } from "utils/helpers";
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import useAPIClientHelper from "./useAPIClientHelper";
import { AxiosResponse } from "axios";
import { Buffer } from "buffer";

function useImageService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getImage = (id: number | string, type: WintSuperkollAPIModel.ImageType, page: number = 0) => {
    return new Promise<string>((resolve, reject) => {
      const response = typeof id === "number" ? getImageByInteger(id, type, page) : getImageByGuid(id, type, page);

      response
        .then((res) => {
          const imgBase64 = Buffer.from(res.data as unknown as string, "binary").toString("base64");
          resolve(imgBase64);
        })
        .catch((e) => {
          resolve("");
        });
    });
  };

  const getImageByInteger = (id: number, type: WintSuperkollAPIModel.ImageType, page: number = 0) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      responseType: "arraybuffer",
    }).ImageClient.GetAsyncByIdasinteger(id, type, page);
  };

  const getImageByGuid = (id: string, type: WintSuperkollAPIModel.ImageType, page: number = 0) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      responseType: "arraybuffer",
    }).ImageClient.GetAsyncByIdasguid(id, type, page);
  };

  /** The whole stored file, with its content type and name in the response headers. */
  const getImageFile = (id: number | string, type: WintSuperkollAPIModel.ImageType): Promise<AxiosResponse<void>> => {
    const imageClient = apiClientInstance(AuthEnums.AuthType.Company, {
      responseType: "arraybuffer",
    }).ImageClient;
    return typeof id === "number"
      ? imageClient.DownloadAsyncByIdasinteger(id, type)
      : imageClient.DownloadAsyncByIdasguid(id, type);
  };

  const downloadImage = async (id: number | string, type: WintSuperkollAPIModel.ImageType) => {
    FileHelper.download(await getImageFile(id, type));
  };

  const getImagesMeta = (entityId: number, type: WintSuperkollAPIModel.ImageType) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .ImageClient.GetMetaAsyncByEntityidasinteger(entityId, type)
      .then((res) => res.data);
  };

  const getImagesMetaByEntityIdAsGuid = (entityIdAsGuid: string, type: WintSuperkollAPIModel.ImageType) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .ImageClient.GetMetaAsyncByEntityidasguid(entityIdAsGuid, type)
      .then((res) => res.data);
  };

  const getFileSize = (fileId: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .ImageClient.GetFileSize(fileId)
      .then((res) => res.data);
  };

  return {
    getImage,
    getImageByInteger,
    getImageByGuid,
    getImageFile,
    downloadImage,
    getImagesMeta,
    getImagesMetaByEntityIdAsGuid,
    getFileSize,
  };
}

export default useImageService;
